import React, { useRef, useState } from "react";

const Overlays = ({ setting, setSetting, setIsSubmit, loader, isSubmit }) => {
  const initialState = {
    selectValue: "",
    inputValue: "",
  };
  const createInitialState = () => ({
    selectValue: "",
    inputValue: "",
  });

  const [rows, setRows] = useState([initialState]);

  const handleSubmit = () => {
    const allSelectValuesEmpty = rows.every((item) => item.selectValue === "");
    if (allSelectValuesEmpty) {
      handleClearAll();
    }
    const hasSelection = rows.some((row) => row.selectValue !== "");

    if (hasSelection) {
      setSetting({ ...setting, overlayParams: rows });
      setIsSubmit(!isSubmit);
    }
  };

  const handleSelectChange_BKP = (index, value) => {
    const newRows = [...rows];
    newRows[index].selectValue = value;

    // Set default value for the input field based on selected option
    switch (value) {
      case "bb":
        newRows[index].inputValue = "20,2";
        break;
      case "sma":
        newRows[index].inputValue = "50";
        break;
      case "ema":
        newRows[index].inputValue = "50";
        break;
      case "psar":
        newRows[index].inputValue = "0.09,0.2";
        break;
      default:
        newRows[index].inputValue = "";
    }

    // Add a new row if conditions are met
    if (newRows.length < 10 && index === newRows.length - 1) {
      newRows.push(createInitialState());
    }

    handleInputChange(index, newRows[index].inputValue);
    setRows(newRows);
  };

  const handleSelectChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].selectValue = value;

    const newColor = generateRandomColor();
    newRows[index].color = newColor;

    // Set default value for the input field based on selected option
    switch (value) {
      case "bb":
        newRows[index].inputValue = "20,2";
        break;
      case "sma":
        newRows[index].inputValue = "50";
        break;
      case "ema":
        newRows[index].inputValue = "50";
        break;
      case "psar":
        newRows[index].inputValue = "0.09,0.2";
        break;
      default:
        newRows[index].inputValue = "";
    }

    // Add a new row if conditions are met
    if (newRows.length < 10 && index === newRows.length - 1) {
      newRows.push(createInitialState());
    }

    handleInputChange(index, newRows[index].inputValue);

    setRows(newRows);
  };

  const generateRandomColor_BKP = (existingColors) => {
    // Function to generate a random HSL color
    const randomHSLColor = () => {
      const hue = Math.floor(Math.random() * 360); // Random hue value (0-360)
      const saturation = Math.floor(Math.random() * 50) + 50; // Random saturation value (50-100)
      const lightness = Math.floor(Math.random() * 30) + 50; // Random lightness value (50-80)
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };

    let newColor;
    const maxAttempts = Math.max(existingColors.length * 1, 10); // Set a maximum of 50 attempts or 10 times the number of existing colors

    for (let i = 0; i < maxAttempts; i++) {
      newColor = randomHSLColor();

      // Check if the new color is significantly different from existing colors
      const isDifferent = existingColors.every((color) => {
        const hsl1 = newColor.match(/(\d+(\.\d+)?)/g).map(Number);
        const hsl2 = color.match(/(\d+(\.\d+)?)/g).map(Number);
        const deltaHue = Math.abs(hsl1[0] - hsl2[0]);
        const deltaSaturation = Math.abs(hsl1[1] - hsl2[1]);
        const deltaLightness = Math.abs(hsl1[2] - hsl2[2]);
        const delta = Math.sqrt(
          deltaHue ** 2 + deltaSaturation ** 2 + deltaLightness ** 2
        );
        return delta >= 150; // Adjust this threshold as needed
      });

      if (isDifferent) {
        return newColor;
      }
    }

    // If no suitable color is found after the maximum attempts, return a fallback color
    return "#000000"; // Fallback to black color
  };

  const generateRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const handleClearAll = () => {
    setRows([initialState]);
    setSetting({
      ...setting,
      clearOverlay: true,
    });
  };
  const handleInputChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].inputValue = value;
    setRows(newRows);
  };

  const isMobileView = document.body.clientWidth <= 768;
  const overlayOptions = [
    { value: "", label: "----None----" },
    { value: "bb", label: "Bollinger Bands" },
    { value: "sma", label: "Simple Moving Avg" },
    { value: "ema", label: "Exp Moving Avg" },
    { value: "psar", label: "Parabolic SAR" },
  ];
  return (
    <div className="bg-custom text-gray-900 m-1 rounded overflow-hidden shadow-lg overflow-visible col-span-3">
      <div className="px-2 py-2">
        <div className="space-y-1 mt-4">
          <div className="flex flex-row">
            <table className="table-auto" style={{ width: "100%" }}>
              <thead>
                <tr className="">
                  <td className="font-bold">Overlays</td>
                  <td className=" font-bold" style={{ width: "100px" }}>
                    Parameters
                  </td>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={`overlay-${index}`}>
                    <td>
                      <select
                        id="overlay"
                        value={row.selectValue}
                        onChange={(e) =>
                          handleSelectChange(index, e.target.value)
                        }
                        className={
                          isMobileView
                            ? "text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            : "text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        }
                      >
                        {overlayOptions
                          .sort((a, b) => a.label.localeCompare(b.label))
                          .map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td className="w-40">
                      <input
                        type="text"
                        id={index}
                        value={row.inputValue}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        placeholder="Enter parameters"
                        className="text-[12px] shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-row px-4">
            <button
              disabled={!setting.period || !setting.symbol}
              onClick={handleSubmit}
              className="bg-primaryColor text-white rounded p-2 mt-2 mr-2 w-full"
              id={"overlayUpdate"}
            >
              {loader ? "Please wait .." : "Update"}
            </button>
            <button
              onClick={handleClearAll}
              className="bg-primaryColor text-white rounded p-2 mt-2 ml-2 w-full"
            >
              {"Clear All"}
            </button>
          </div>
        </div>
        {/* {showWarning && (
          <WarningDialog onClose={() => setShowWarning(false)} />
        )} */}
      </div>
    </div>
  );
};

export default Overlays;
